import { defineMessages } from 'react-intl';

export default defineMessages({
    heading: {
        id: 'profile.heading',
        defaultMessage: 'Account & Rider Profiles',
        description: 'Profile page heading and title',
    },
    intro: {
        id: 'profile.intro',
        defaultMessage:
            'Coming soon... edit your account information and rider profiles.',
        description: 'Profile page heading intro',
    },
    account_heading: {
        id: 'profile.account_heading',
        defaultMessage: 'Account',
        description: 'Profile account page heading',
    },
    name_label: {
        id: 'profile.name_label',
        defaultMessage: 'Name',
        description: 'Profile page name field label',
    },
    name_error: {
        id: 'profile.name_error',
        defaultMessage: 'Please enter a name',
        description: 'Profile page name field error',
    },
    gender_label: {
        id: 'profile.gender_label',
        defaultMessage: 'Gender',
        description: 'Profile page gender field label',
    },
    gender_male_label: {
        id: 'profile.gender_male_label',
        defaultMessage: 'male',
        description: 'Profile page gender field male option label',
    },
    gender_female_label: {
        id: 'profile.gender_female_label',
        defaultMessage: 'female',
        description: 'Profile page gender field female option label',
    },
    email_label: {
        id: 'profile.email_label',
        defaultMessage: 'Email',
        description: 'Profile page email field label',
    },
    email_error: {
        id: 'profile.email_error',
        defaultMessage: 'Please enter a valid email',
        description: 'Profile page email field error',
    },
    password_label: {
        id: 'profile.password_label',
        defaultMessage: 'Password',
        description: 'Profile page password field label',
    },
    password_error: {
        id: 'profile.password_error',
        defaultMessage: 'Please enter a password',
        description: 'Profile page password field error',
    },
    bike_type_label: {
        id: 'profile.bike_type_label',
        defaultMessage: 'Bike Type',
        description: 'Profile page rider profile bike type field label',
    },
    bike_type_road_label: {
        id: 'profile.bike_type_road_label',
        defaultMessage: 'Road',
        description:
            'Profile page rider profile bike type field road option label',
    },
    bike_type_mountain_label: {
        id: 'profile.bike_type_mountain_label',
        defaultMessage: 'Mountain',
        description:
            'Profile page rider profile bike type field mountain option label',
    },
    bike_type_city_label: {
        id: 'profile.bike_type_city_label',
        defaultMessage: 'City',
        description:
            'Profile page rider profile bike type field city option label',
    },
    position_label: {
        id: 'profile.position_label',
        defaultMessage: 'Position',
        description: 'Profile page rider profile position field label',
    },
    position_low_label: {
        id: 'profile.position_low_label',
        defaultMessage: 'Low',
        description:
            'Profile page rider profile position field low option label',
    },
    position_medium_label: {
        id: 'profile.position_medium_label',
        defaultMessage: 'Medium',
        description:
            'Profile page rider profile position field medium option label',
    },
    position_high_label: {
        id: 'profile.position_high_label',
        defaultMessage: 'High',
        description:
            'Profile page rider profile position field high option label',
    },
    ride_frequency_label: {
        id: 'profile.ride_frequency_label',
        defaultMessage: 'Frequency',
        description: 'Profile page rider profile ride frequency field label',
    },
    ride_frequency_once_month_label: {
        id: 'profile.ride_frequency_once_month_label',
        defaultMessage: 'Once per month',
        description:
            'Profile page rider profile ride frequency field once a month option label',
    },
    ride_frequency_once_week_label: {
        id: 'profile.ride_frequency_once_week_label',
        defaultMessage: 'Once per week',
        description:
            'Profile page rider profile ride frequency field once a week option label',
    },
    ride_frequency_three_week_label: {
        id: 'profile.ride_frequency_three_week_label',
        defaultMessage: '3 Times per week',
        description:
            'Profile page rider profile ride frequency field three times a week option label',
    },
    ride_frequency_six_week_label: {
        id: 'profile.ride_frequency_six_week_label',
        defaultMessage: '6 Times per week',
        description:
            'Profile page rider profile ride frequency field six times a week option label',
    },
    ride_duration_label: {
        id: 'profile.ride_duration_label',
        defaultMessage: 'Duration',
        description: 'Profile page rider profile ride duration field label',
    },
    ride_duration_short_label: {
        id: 'profile.ride_duration_short_label',
        defaultMessage: '0-30 minutes',
        description:
            'Profile page rider profile ride duration field 0-30 minutes option label',
    },
    ride_duration_medium_label: {
        id: 'profile.ride_duration_medium_label',
        defaultMessage: '30-60 minutes',
        description:
            'Profile page rider profile ride duration field 30-60 minutes option label',
    },
    ride_duration_long_label: {
        id: 'profile.ride_duration_long_label',
        defaultMessage: '60-90 minutes',
        description:
            'Profile page rider profile ride duration field 60-90 minutes option label',
    },
    ride_duration_extended_label: {
        id: 'profile.ride_duration_extended_label',
        defaultMessage: '90+ minutes',
        description:
            'Profile page rider profile ride duration field 90+ minutes option label',
    },
});



// WEBPACK FOOTER //
// ./src/client/pages/profile/messages.js